import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';

import { translations } from '@/locale';

import { SessionConsumer } from '@/components/Context/Session';
import UserProfileImage from '@/components/UserProfileImage/UserProfileImage';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

const text = translations.header.profile;

const ProfileDropdown: React.FC<RouteComponentProps> = ({ history }) => (
  <SessionConsumer>
    {({ me, signOut }) => (
      <Popover>
        <PopoverTrigger>
          <UserProfileImage
            url={null}
            firstName={me.firstName}
            lastName={me.lastName}
            className="w-10 h-10 rounded-full mr-2.5 group-hover:shadow-red transition"
          />
        </PopoverTrigger>
        <PopoverContent className="bg-white space-y-2">
          <div>
            <p className="text-sm" role="none">
              Signed in as
            </p>
            <p className="text-sm font-medium text-gray-900" role="none">
              {me.email}
            </p>
          </div>
          <button
            type="button"
            onClick={signOut}
            className="block text-sm text-red-700 font-bold"
            role="menuitem"
            id="user-menu-item-1"
          >
            <FormattedMessage id={text.signOut} />
          </button>
        </PopoverContent>
      </Popover>
    )}
  </SessionConsumer>
);

export default withRouter(ProfileDropdown);
